// extracted by mini-css-extract-plugin
export default {"rotateLeft":"styles_rotateLeft__xj8FF","rotateTop":"styles_rotateTop__3OJbd","rotateRight":"styles_rotateRight__LNae8","rotateBottom":"styles_rotateBottom__kzS3b"};